import { SubscriptionPackageType } from 'services/programming'
import { useMyActiveSubscriptions } from './subscriptions'

export function useProductAccess(): Set<SubscriptionPackageType> {
  const subscriptions = useMyActiveSubscriptions()

  if (subscriptions) {
    return new Set(
      subscriptions.map((s) => s.package.name as SubscriptionPackageType),
    )
  }

  return new Set<SubscriptionPackageType>()
}
